var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mhi-modal-wrapper"},[_c('div',{staticClass:"mhi-modal-body loader"},[_c('div',{class:[_vm.animateClass, _vm.colorClass],attrs:{"role":"status"}}),_c('span',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }